"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ERROR_MESSAGE = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _react = require("react");
var _cnbuilder = require("cnbuilder");
var _uuid = require("uuid");
var _useValidation = _interopRequireDefault(require("../Form/use-validation"));
var _RadioModule = _interopRequireDefault(require("./Radio.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = ["classNameRoot", "classNameItem", "classNameSelector", "classNameControl", "classNameLabel", "testAttrRoot", "testAttrItem", "id", "name", "label", "value", "disabled", "readOnly", "required", "defaultChecked", "parentValidationState", "isParentValid", "onChange", "onInvalid"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const ERROR_MESSAGE = exports.ERROR_MESSAGE = "You cannot set both disabled and readOnly properties on the Radio. Use readOnly when you want to restrict a user from changing the radio checked state, but don't want to disable the keyboard focus, screen-reader access, and form serialization.";
const Radio = _ref => {
  let {
      classNameRoot,
      classNameItem,
      classNameSelector,
      classNameControl,
      classNameLabel,
      testAttrRoot,
      testAttrItem,
      id,
      name,
      label,
      value,
      disabled,
      readOnly,
      required,
      defaultChecked,
      parentValidationState,
      isParentValid,
      onChange,
      onInvalid
    } = _ref,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  (0, _react.useEffect)(() => {
    if (disabled && readOnly) {
      throw new Error(ERROR_MESSAGE);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const {
    ref,
    setValidationState
  } = (0, _useValidation.default)({
    id,
    disabled,
    onInvalid
  });
  const onChangeCallback = evt => {
    if (readOnly) {
      // don't allow to change the radio state
      evt.preventDefault();
      return;
    }
    if (onChange) {
      onChange(evt);
    }
  };
  const onInvalidCallback = evt => {
    evt.preventDefault();
  };
  const {
    current: uuid
  } = (0, _react.useRef)((0, _uuid.v4)());
  const labelId = "radio-label-".concat(uuid);
  (0, _react.useEffect)(() => {
    // if the parent RadioGroup validation state changes, make sure to update
    // this item's validation state so that it is not out of sync with the parent
    setValidationState(parentValidationState);
  }, [setValidationState, parentValidationState]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    "data-test": testAttrRoot,
    className: (0, _cnbuilder.cnb)(_RadioModule.default.root, {
      [_RadioModule.default.readOnly]: readOnly
    }, classNameRoot),
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: (0, _cnbuilder.cnb)(_RadioModule.default.control, classNameControl),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", _objectSpread(_objectSpread({
        "data-test": testAttrItem,
        ref: ref,
        className: (0, _cnbuilder.cnb)(_RadioModule.default.item, classNameItem),
        id: id,
        type: "radio",
        name: name,
        value: value,
        defaultChecked: defaultChecked,
        onClick: onChangeCallback,
        disabled: disabled,
        required: required,
        onInvalid: onInvalidCallback,
        "aria-labelledby": labelId
        // Attribute below fixes screenreader bug on iOS (must be added conditionally to work properly)
      }, isParentValid && {
        'aria-invalid': false
      }), rest)), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        "aria-hidden": "true",
        className: (0, _cnbuilder.cnb)(_RadioModule.default.selector, classNameSelector)
      }), /*#__PURE__*/(0, _react.cloneElement)(label, {
        htmlFor: id,
        className: (0, _cnbuilder.cnb)(_RadioModule.default.label, classNameLabel),
        id: labelId,
        'aria-hidden': true
      })]
    })
  });
};
Radio.defaultProps = {
  testAttrRoot: 'radio-root',
  testAttrItem: 'radio-item'
};
var _default = exports.default = Radio;